<template>
  <div class="micro-histogram">
    <svg ref="svg" :width="size.width" :height="size.height"><defs /></svg>
    <Transition name="fade">
      <div v-if="tooltip" class="tooltip" :style="fixedTooltip || {top: tooltip.top, left: tooltip.left}">
        <div class="value">{{ valueFormat(tooltip.start) }} - {{ valueFormat(tooltip.start+data.bucketSize) }} </div>
        <div class="label"> {{ $t('count') }}: <span class="count">{{ tooltip.count }}</span></div>
      </div>
    </Transition>
  </div>
</template>

<script>
import {select as d3_select} from 'd3-selection'
import {max as d3_max} from 'd3-array'
import {axisBottom as d3_axisBottom} from 'd3-axis'
import {scaleBand as d3_scaleBand, scaleLinear as d3_scaleLinear} from 'd3-scale'
import {bcnColors} from '@/utils/colorUtils'
import Size from '@/mixins/Size'
import { format as d3_format } from 'd3-format'

export default {

  mixins:[Size],
  props: ['data','fixedTooltip'],
  data(){
    return {
      tooltip: null
    }
  },
  watch:{
    size(){
      this.drawChart()
    }
  },
  mounted() {
    this.drawChart()
  },
  methods:{
    valueFormat(v){
      return d3_format(".2s")(v)
    },
    drawChart(){
      if(!this.data) return
      let width = this.size.width
      let height = this.size.height-13
      let x = d3_scaleBand().domain(this.data.buckets.map((d)=>d.start)).range([0,width]).padding(0.2).paddingOuter(0.4)
      let y = d3_scaleLinear().domain([0,d3_max(this.data.buckets,(d)=>d.count)]).range([height,0])
      let root = d3_select(this.$refs.svg).selectAll('.root').data([null])
      root = root.merge(root.enter().append('g').attr('class','root'))
      let items = root.selectAll('.item').data(this.data.buckets,(d)=>d.start)
      let itemsEnter = items.enter().append('g').attr('class','item')
      itemsEnter.append('rect')
      
      items = items.merge(itemsEnter)
      items.select('rect')
      .attr('x',(d)=>x(d.start))
      .attr('y',(d)=>y(d.count))
      .attr('width',()=>x.bandwidth())
      .attr('height',d=>y(0) - y(d.count))
      .attr('fill',bcnColors[0])
      // root.attr('transform',`translate(${width/2},${height/2})`)
      
      
      items.on('mouseenter',(e,d)=>{
        this.tooltip = {...d, top: 0+'px',left:x(d.start)+'px'}
        items.classed('active',(dd)=>dd===d).classed('innactive',(dd)=>dd!==d)
      })
      items.on('mouseleave',()=>{
        this.tooltip=null
        items.classed('active',false).classed('innactive',false)
      })
      
      let axis = root.selectAll('.axis').data([null])
      axis = axis.merge(axis.enter().append('g').attr('class','axis'))
      let ids = this.data.buckets.map((d)=>d.start)
      let ticks = [{value: ids[0], label: ids[0]},{value: ids[ids.length-1], label:ids[ids.length-1]+this.data.bucketSize}]
      let xAxis = d3_axisBottom(x).tickSize(1).tickValues(ticks.map((d)=>d.value)).tickFormat((d,i)=>this.valueFormat(ticks[i].label))
      axis.call(xAxis)
      axis.attr('transform',`translate(0,${height})`)
    }
  }
}
</script>

<style lang="stylus" scoped>
.micro-histogram
  // background #545
  // border solid 1px
  // padding vw(20px)
  display flex
  width 100%
  height 100%
  svg
    margin auto
    font-weight normal
    color $grey
    // >>> .axis
    //   font-size 12px
      
  .micro-stats &
    svg
      >>> .axis
        font-size 12px
</style>
